import filters from './filters';

export { allOperators, allLogical } from './FilterOptions';
export default filters;
